<template>
  <div>
    <canvas ref="chart"></canvas>
    <p v-show="loading">Carregando</p>
  </div>
</template>
<script>
import Chart from 'chart.js';
import { uniq } from 'lodash';
import Colors from '@/utils/colors';
export default {
  name: 'PlanChart',
  data() {
    return {
      loading: false
    };
  },

  methods: {
    mountChart(payments = []) {
      this.loading = true;
      const labels = uniq(payments.map(p => p.covenant));

      const data = [];
      labels.forEach(label => {
        const paymentsCovenant = payments.filter(p => p.covenant == label);
        data.push(paymentsCovenant.length);
      });

      const chartDate = {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [
            {
              backgroundColor: Colors.pallet(labels.length),
              label: 'Convênio',
              data: data
            }
          ]
        },
        options: {}
      };

      const canvas = this.$refs.chart;
      new Chart(canvas, chartDate);
      this.loading = false;
    }
  }
};
</script>
